import React, { useState, useEffect, useRef } from 'react';
import './index.css';
import { RecentSearchesSection } from './RecentSearches';
import SearchFields from './searchFields';
import SearchResults from './../result/index';
import { restoreSavedSearch } from "./queryParams";

const SearchBox = (props) => {
    const [showResults, setShowResults] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useState(null);
    const [customerid, setCustomerid] = useState(null);
    const [historyParams, setHistoryParams] = useState(null);
    const [search, setSearch] = useState(false);
    const searchSourceRef = useRef('check_rates')

    // saveSearchHistory persists the current form body so it shows up under
    // "Recent searches". The backend tags it source=ppe to keep it separate from
    // the legacy Rates history. Best-effort: history is non-critical, so failures
    // are swallowed and never block the search.
    const saveSearchHistory = (body) => {
        fetch("/los/priceengine/addsearchhistory", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
            },
            body: JSON.stringify(body),
        }).catch(() => {});
    };

    const handleCheckRates = (body, source) => {
        searchSourceRef.current =
            source === 'history' || source === 'top_search' || source === 'check_rates' || source === 'alternative'
                ? source
                : 'check_rates'
        setSearch(false);
        setTimeout(() => {
            setLoading(true);
            // 添加时间戳确保每次调用都有变化
            setSearchParams({...body, _timestamp: Date.now()});
            setCustomerid(localStorage.getItem("customerid"));
            setShowResults(true);
            // setSearch(true);
        }, 0);
        saveSearchHistory(body);
    };

    // A recent search was picked (the list under the form, source
    // 'top_search', or the header list, source 'history'). `params` is the
    // stored form body (full shape, incl. ppe*/nonQm) after rerunParameters.
    // Because we persist the body shape, restore is a plain re-run: pass it
    // straight to handleCheckRates and repopulate the form via historyParams —
    // no lossy re-mapping that would drop the new PPE fields.
    // restoreSavedSearch only brings an old body up to today's form (D17).
    const handleApplyParams = (params, source) => {
        const stored = restoreSavedSearch(params);
        const body = {
            ...stored,
            downPayment: stored.purpose === "Purchase" && !["heloc", "secondMortgage"].includes(stored.loanProgram)
                ? stored.propertyValue - stored.loanAmount
                : undefined,
        };
        setHistoryParams({ ...body, from: "history" });
        handleCheckRates(body, source);
    }

    const handleRefineSearch = (params) => {
        // console.log('refine search', params)
        setHistoryParams({...params, from: "result"});
    }

    // A change suggestion (work package 8) was clicked: refill the form with
    // the changed search and run it.
    const handleApplyAlternative = (body) => {
        setHistoryParams({ ...body, from: "result" });
        handleCheckRates(body, 'alternative');
    };

    const handleBackToResult = () => {
        setShowResults(true);
        setSearch(false);
    }

    useEffect(() => {
        // A search picked from the header's Recent searches list (PPEPricing.js).
        if (props.recent && props.recent.parameters) {
            handleApplyParams(props.recent.parameters, 'history');
        }
    // Rerun only when a new pick arrives.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.recent])

    return <div className='search-box'>
        {!showResults && <SearchFields onCheckRates={handleCheckRates} historyParams={historyParams} onBackToResult={handleBackToResult}/>}
        {!showResults && !searchParams && <RecentSearchesSection onPick={(params) => handleApplyParams(params, 'top_search')} />}
        {searchParams && <SearchResults 
            style={{display: showResults ? "block" : "none"}}
            searchParams={searchParams} 
            customerid={customerid}
            loading={loading}
            setLoading={setLoading}
            search={search}
            setChangeShowResults={() => setShowResults(false)}
            onRefineSearch={handleRefineSearch}
            onApplyAlternative={handleApplyAlternative}
            searchSource={searchSourceRef.current}
        />}
    </div>;
};

export default SearchBox;
